import React from "react";
import Slider from "../../common/Slider";
import { Link } from "react-router-dom";

const advantages = [
  {
    title: "Great Doctors",
    summary:
      "Prasad Eye Hospital offers top-tier eye specialists, including experts in Glaucoma, Phaco, and Vitreo Retina surgery. Our highly experienced team ensures exceptional, personalized care.",
    img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/advantages/ad1.jpg",
    imgAlt: "advantage1",
  },
  {
    title: "Complete Eye Solutions",
    summary:
      "We provide comprehensive care with dedicated doctors, an in-house pharmacy, and optical services, ensuring all your eye health needs are met with expertise and ease.",
    img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/advantages/ad2.jpg",
    imgAlt: "advantage2",
  },
  {
    title: "Great Facilities",
    summary:
      "We deliver top-notch eye care with the latest glaucoma and retinal lasers, advanced OCT, ultrasound, and high-precision Phaco platforms for precise treatment.",
    img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/advantages/ad4.jpg",
    imgAlt: "advantage4",
  },
  {
    title: "World Class Equipment",
    summary:
      "Our state-of-the-art, branded equipment ensures reliable, accurate services, offering exceptional performance that matches the best in global eye care standards.",
    img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/advantages/ad3.jpg",
    imgAlt: "advantage3",
  },
];

const advantageComponent = () => {
  return advantages.map((adv) => (
    <div className="featured-imagebox featured-imagebox-services style1">
      <div className="featured-thumbnail">
        <a href="branding-strategy.html">
          <img className="img-fluid" src={adv.img} alt={adv.imgAlt} />
        </a>
      </div>
      <div className="featured-content">
        <div className="featured-title">
          <h3>{adv.title}</h3>
        </div>
        <div className="featured-desc">
          <p>{adv.summary}</p>
        </div>
      </div>
    </div>
  ));
};

function Advantage({ setTab }) {
  return (
    <section className="ttm-row broken-section clearfix">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div className="col-bg-img-one ttm-col-bgimage-yes ttm-left-span ttm-bg">
              <div className="ttm-col-wrapper-bg-layer ttm-bg-layer"></div>
              <div className="layer-content padding_bottom40 padding_top40">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="section-title title-style-center_text">
                      <div className="title-header">
                        <h3>Best Vision</h3>
                        <h2 className="title">Eye Health And Vision Care</h2>
                      </div>
                      <div className="heading-seperator">
                        <span></span>
                      </div>
                      <div className="title-desc">
                        <p>
                          Placing you and your safety at the heart of everything
                          we do with an excellent team of super specialized doctors
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row" id="advantage-section">
                  <Slider
                    sliders={advantageComponent()}
                    slidesToShow={3}
                    autoplaySpeed={3000}
                    responsive={true}
                  />
                </div>
                <div className="text-center margin_top50 res-991-margin_top30">
                  <h4 className="fs-18">
                    Get The Best Eye Care With Our Doctors!
                  </h4>
                  <h2 className="fs-22">
                    Welcome To{" "}
                    <span className="ttm-textcolor-skincolor"> Prasad </span>
                    Eye Hospital
                  </h2>
                  <Link
                    to="/appointment"
                    className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-border ttm-btn-color-dark margin_top15"
                    onClick={() => setTab("appointment")}
                  >
                    Book Appointment
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Advantage;
